import axios from "../../../axios";

export const activateSubscription = async token => {

    return await axios.patch('/subscription/activate', {sessionToken: token})
}